<template>
  <div class="calendar bg_white pb16">
    <div class="calendar_head">
      <button class="btn prev" @click="prevMonth"><img src="@/assets/images/calendar/prev.png" alt=""></button>
      <div class="current_date rb">{{ currentDate.format('Y') }}<span class="year ab">年</span>{{ currentDate.format('M') }}<span class="month ab">月</span></div>
      <button class="btn next" @click="nextMonth"><img src="@/assets/images/calendar/next.png" alt=""></button>
    </div>
    <div class="calendar_contents">
      <div class="calendar_weekly">
        <div class="calendar_day ar c5a" v-for="n in 7" :key="n">
          {{ calendarDay(n-1) }}
        </div>
      </div>

      <div class="calendar_weekly day_weeky" v-for="(week, index) in getCalendar()" :key="index">
        <div class="calendar_day rr c5a" v-on:click="selectDate(currentDate.format('Y-MM') + '-' + ('00' + day.date).slice(-2))" v-for="(day, index) in week" :key="index" v-bind:data-date="currentDate.format('Y-MM') + '-' + ('00' + day.date).slice(-2)">
          <span class="day" v-bind:class="{'today': currentDate.format('Y-MM') + '-' +  ('00' + day.date).slice(-2) == todayDate, 'select': currentDate.format('Y-MM') + '-' +  ('00' + day.date).slice(-2) == selectDay}">{{ day.date }}</span>
          <div class="schedule_wrap">
            <span v-if="eventDate(currentDate.format('Y-MM') + '-' + ('00' + day.date).slice(-2))" class="schedule" :style="{background: getColor(currentDate.format('Y-MM') + '-' + ('00' + day.date).slice(-2))}"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';


const today = new Date();
export default {
  props: ['checkDate'],
  data () {
    return {
      todayDate: moment(today).format('Y-MM-DD'),
    }
  },
  methods: {
    calendarDay(index) {
      const week = ['日', '月', '火', '水', '木', '金', '土'];
      return week[index];
    },
    getStartDate() {
      let date = moment(this.currentDate);
      date.startOf('month');
      const dayNum = date.day();
      return date.subtract(dayNum, 'days');
    },
    getEndDate() {
      let date = moment(this.currentDate);
      date.endOf("month");
      const youbiNum = date.day();
      return date.add(6 - youbiNum, 'days');
    },
    getCalendar() {
      let startDate = this.getStartDate();
      let endDate = this.getEndDate();
      let weekNumber = Math.ceil(endDate.diff(startDate, 'days') / 7);

      // 当月の日付の開始位置を取得
      let date = moment(this.currentDate);
      date.startOf('month');
      const dayNum = date.day();

      let calendars = [];
      for (let week = 0; week < weekNumber; week++) {
        let weekRow = [];
        for (let day = 0;  day < 7; day++) {
          if (calendars.length == 0 && day < dayNum) {
            // 前月の日付を空白にする
            weekRow.push({ date: '' });
          } else if (calendars.length + 1 == weekNumber && 0 < startDate.get('date') && startDate.get('date') < 7) {
            // 次月の日付を空白にする
            weekRow.push({ date: '' });
          } else {
            weekRow.push({ date: startDate.get('date') });
          }
          startDate.add(1, 'days');
        }
        calendars.push(weekRow);
      }
      return calendars;
    },
    nextMonth() {
      this.$store.commit('salon/setCurrentDate', moment(this.currentDate).add(1, 'month'));
    },
    prevMonth() {
      this.$store.commit('salon/setCurrentDate', moment(this.currentDate).subtract(1, 'month'));
    },
    eventDate(date) {
      for (var i = 0; i < this.checkDate.length; i++) {
        if (this.checkDate[i].day == date) {
          return true;
        }
      }
      return false;
    },
    selectDate(date) {
      this.$store.commit('salon/setSelectDay', moment(date).format('Y-MM-DD'));
    },
    getColor(date) {
      for (var i = 0; i < this.checkDate.length; i++) {
        if (this.checkDate[i].day == date) {
          return this.checkDate[i].color;
        }
      }
    },
    initialized() {
      if(this.selectDay == null) {
        this.$store.commit('salon/setSelectDay', moment(today).format('Y-MM-DD'));
      }
      if(this.currentDate == null) {
        this.$store.commit('salon/setCurrentDate', moment());
      }
    },
  },
  beforeMount(){
    this.initialized();
  },
  computed: mapGetters(
    'salon', ['selectDay', 'currentDate'],
  ),
  watch: {
    selectDay() {
      this.initialized();
    },
  }
}
</script>

<style lang="css" scoped>
.calendar_contents {
  max-width: 311px;
  margin: auto;

}
.calendar_weekly {
  display: flex;
  justify-content: space-between;
}
.day_weeky {
  border-bottom: 1px solid  #bfbfbf;
}
.calendar_day {
  font-size: 12px;
  height: 44px;
  padding: 0 0 17px;
  text-align: center;
  width: calc(100% / 7);
}

.calendar_head {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 15px 20px;
}
.current_date {
  font-size: 22px;
}
.year, .month {
  font-size: 16px;
}
.year {
  margin: 0 2px;
}
.btn {
  border: none;
  background: transparent;
}
.btn img {
  width: 8px;
}
.day {
  display: block;
  height: 22px;
  margin: 2px auto 0;
  position: relative;
  padding-top: 4px;
  width: 22px;
  z-index: 1;
}

.select {
  color: #fff;
}

.select::before {
  background-color: #0E9AFF;
  border-radius: 50px;
  content: '';
  height: 100%;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: -1;
}

.today {
  color: #fff;
}
.today::before {
  background-color: #FF6A6A;
  border-radius: 50px;
  content: '';
  height: 100%;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: -1;
}

.schedule_wrap {
  align-items: center;
  display: flex;
  justify-content: space-around;
  margin-top: 2px;
}
.schedule {
  border-radius: 50%;
  display: block;

  height: 7px;
  width: 7px;
}
.schedule.blue {
  background: #0E9AFF;
}
</style>



// WEBPACK FOOTER //
// src/components/salon/Calendar.vue